module.exports = __webpack_public_path__ + "static/media/Orange_Button.1be5a5c5.png";